import { Divider, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { useContext } from "react";
import { UserContext } from "../UserContext";
import { AddressDetail } from "./Sections/AddressDetail";
import { ContactDetail } from "./Sections/ContactDetail";
import { TextDetail } from "./Sections/TextDetail";

import { isMobile } from "react-device-detect";
import { ApiContext } from "../ApiContext";
import { AdminDetail } from "./Sections/AdminDetail";
import { BillingDetail } from "./Sections/BillingDetail";
import { PhotoDetail } from "./Sections/PhotoDetail";

export const LocationForm = ({ images, fetchLocationImages }) => {

	const { ApiCall } = useContext(ApiContext);

	const { selectedLocation, setSelectedLocation } = useContext(UserContext);

	const refreshPage = () => {
		ApiCall("GET", `client/locations`, null)
			.then((res) => {
				let loc = res.find((loc) => loc.id === selectedLocation.id);
				setSelectedLocation(loc);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Stack
				direction={isMobile ? "column" : "row"}
				justifyContent={"space-between"}
			>
				<Stack
					sx={{
						width: isMobile ? "100%" : "48%"
					}}
					spacing={2}
				>
					<TextDetail
						data={selectedLocation}
						refreshData={refreshPage}
						images={images}
					/>
					<Divider />
					
					<AddressDetail
						data={selectedLocation}
						refreshData={refreshPage}
					/>
					<Divider />

					<ContactDetail
						data={selectedLocation}
						refreshData={refreshPage}
					/>

					<Divider />

					<BillingDetail
						data={selectedLocation}
						refreshData={refreshPage}
					/>

					<Divider />

					<AdminDetail data={selectedLocation} />

					<Divider />

					<PhotoDetail
						data={selectedLocation}
						images={images}
						refreshData={fetchLocationImages}
					/>
				</Stack>
			</Stack>
		</Box>
	);
};
